import { render, staticRenderFns } from "./CourseOutcomesSemesters.vue?vue&type=template&id=20c55f80"
import script from "./CourseOutcomesSemesters.vue?vue&type=script&lang=js"
export * from "./CourseOutcomesSemesters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports